import { ArrayLoading, EntityLevel } from '@/store/types'

import { loading, none } from '@/store/constants'

import {
  Active,
} from '../editor/types'

import {
  ActiveSite,
  Site,
} from './types'

import { blankEditBase, blankImage } from '@/store/editor/constants'

import _ from 'lodash'

export const loadingSite: ArrayLoading<Site> = _.assign([], loading)

export const active: Active = _.assign({ entityLevel: EntityLevel.None, isNone: false, id: -1, Name: '', DisplayName: '', Visible: true, OrderBy: 0, Created: false }, blankEditBase)

export const blankSite: Site = _.assign({ Name: 'none', DisplayName: 'None', BrowserTitle: '', LogoPath: '', LogoLink: '', LogoImageId: -1, FaviconImageId: -1, FaviconPath: '', LogoImage: blankImage, FaviconImage: blankImage, ShowInventory: false, EnableExport: false, HasPricing: false, ShowCatalog: false, Servers: [] }, blankEditBase)

export const noneSite: Site = _.assign({}, blankSite, none)

export const activeSiteNone: ActiveSite = _.assign({}, noneSite, active, none)
